<template>
    <!-- Usage statement Modal component (this gets shared by ServicePoints and Reports) -->
    <div class="modal-usage">
        <modal v-show="isUsageStatementModalVisible === true" @close="closeModal()">
            <h4 class="modal-title" slot="header">{{ $t("message.usagestatement") }}</h4>
            <div slot="body">
                <span id="usageData" name="usageData">
                    <UsagePopup v-bind:billingCycleAssignmentID="selectedBillingCycleAssignmentId" v-bind:premiseId="selectedPremiseId" />
                </span>
            </div>
            <div slot="footer">
                <button class="btn btn-primary" @click="printPopupToPDF()">{{ $t("message.convertToPDF") }}</button>
                <button class="btn btn-primary" @click="printPopup()">{{ $t("message.print") }}</button>
                <button class="btn btn-primary" @click="closeModal()">{{ $t("message.close") }}</button>
            </div>
        </modal>
        <!--Sneaky workaround, apparently necessary to render PDF / print.  
        https://stackoverflow.com/questions/43537121/how-to-get-html-content-of-component-in-vue-js -->
        <div id="pdfData">
            <UsagePopup v-show="false" ref="printHTML" v-bind:billingCycleAssignmentID="selectedBillingCycleAssignmentId" v-bind:premiseId="selectedPremiseId"></UsagePopup>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Modal from '@/components/common/Modal';
import UsagePopup from '@/components/dashboard/UsagePopup';

var usageCss = "<style type='text/css'> \
        .table { width: 100%; margin-bottom: 20px; max-width: 100%; background-color: transparent } \
        .table-striped>tbody>tr:nth-child(odd)>td, .table-striped>tbody>tr:nth-child(odd)>th { background-color: #f7f7f7 !important; } \
        .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th { padding: 5px; line-height: 1.428571429; vertical-align: top; border-bottom: 1px solid gray; } \
        .usageBreakdown {font-family:Arial;font-size:12px;} \
        .usageBreakdownNumber {font-family:Arial;font-size:12px;text-align:right;} \
        .mainRow { width:700px; clear:both; overflow:visible; font-family:Arial; font-size: 9pt; background-color:White;  } \
        .topRow .floater{ height:100px; } \
        .floater{ float:left; margin:3px; padding:6px; font-family:Arial; font-size: 9pt; background-color:White; } \
        .floaterRight{ float:right; margin:3px; padding:6px; font-family:Arial; font-size: 9pt; background-color:White; box-sizing: border-box; display:block;  } \
        .floaterRight .tr .td {font-family:Arial; font-size: 9pt;} \
        .totalBar td{ border-top:1px #f1f1f1 solid; font-weight:bold; font-family: Arial;font-size:9pt; } \
        .titleRow td{ font-weight:bold; border-top:1px #f1f1f1 solid; border-bottom:1px #f1f1f1 solid;} \
        .lblCaption{ font-weight:bold; } \
        .breakdownTable td { border-bottom:1px #f1f1f1 solid; padding-left:5px; padding-right:5px; text-align:center; font-family:Arial; font-size: 9pt; background-color:White;  } \
        .breakdownTable{ font-family:Arial; font-size: 9pt; background-color:White; } \
        .sideBorders{ border-left:1px #f1f1f1 solid; border-right:1px #f1f1f1 solid; } \
        .bordered{ border:1px #f1f1f1 solid; margin:3px 3px 3px 3px; } \
        .divDetails > div{ font-size:10pt; font-weight:bold; } \
        .divDetails > table, .divDetails > span > table{ margin-left:22px; width:650px; } \
        .rowSubTotal td, .rowSubTotal , .rowSubTotal .tableColumn3{ font-weight:bold; border-left:0px; border-right:0px; border-bottom:0px; width:100px; } \
        .tableColumn1 { width:50%; border-left:1px #f1f1f1 solid; border-bottom: 1px; text-align: left !important; } \
        .tableColumn2 { width:30%; border-bottom: 1px; text-align: left !important; } \
        .tableColumn3 { width:20%; border-right:1px #f1f1f1 solid; border-bottom: 1px; text-align: right !important; } \
        pre {border: none; background: transparent; font-family:Arial; font-size: 9pt; background-color:White; padding:0px;} \
        .usage-statement-left .logo { max-height: 85px; } \
        .usage-statement-right { border: 1px solid #f1f1f1; padding: 10px; margin-top: 10px; } \
        .usage-statement-right span { padding-bottom: 2px; } \
    </style>";

export default {
    name: 'UsageStatementModal',
    components: {
        Modal,
        UsagePopup
    },
    props: {
        selectedPremiseId: -1,
        selectedBillingCycleAssignmentId: -1,
        selectedBillingCycleId: -1,
        isUsageStatementModalVisible: false
    },
    methods: {
        closeModal() {
            this.isUsageStatementModalVisible = false;
        },
        printPopup() {
            var htmlData = this.$refs.printHTML.$el.innerHTML;
            var w = window.open();
            w.document.write(usageCss + htmlData);
            w.document.close();
            w.focus();
            w.print();
            w.close();

        },
        printPopupToPDF() {
            var htmlData = this.$refs.printHTML.$el.innerHTML;
            axios({
                method: "POST",                
                url: this.$httpAxiosBaseUrl() + "Report/DownloadUsage",
                data: {
                    pageHtml : usageCss + htmlData
                },
            }).then(result => {
                var result = result.data;
                var fileBytes = this.$base64ToArrayBuffer(result);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var blob = new Blob([fileBytes], {type: "application/pdf"});
                    window.navigator.msSaveBlob(blob, "UsageStatement.pdf");
                }
                else {
                    this.$saveByteArray("UsageStatement.pdf", fileBytes);
                }
            });
        }
    },
    watch: {
        selectedPremiseId(val) {
            this.selectedPremiseId = val;
        },
        selectedBillingCycleAssignmentId(val) {
            this.selectedBillingCycleAssignmentId = val; 
        },
        isUsageStatementModalVisible(val) {
            this.$emit('update:isUsageStatementModalVisible', val);
        }
    }  
}
</script>
